export const CREATE_PAYMENT_INTENT_EDNPOINT = `${process.env.GATSBY_BACKEND_API_URL}/create-payment-intent`
export const CREATE_STRIPE_ACCOUNT = `${process.env.GATSBY_BACKEND_API_URL}/create-stripe-account`
export const CREATE_SIGNUP_ACCOUNT_LINK = `${process.env.GATSBY_BACKEND_API_URL}/create-signup-account-link`
export const GET_STRIPE_ACCOUNT = accountId =>
  `${process.env.GATSBY_BACKEND_API_URL}/account/${accountId}`
